<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="antrian-klinik">
      <div class="sticky-table-header">
        <vx-card style="overflow-x: auto;">
          <vs-row>
            <vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
              <vs-input ref="searchTxt" icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Pencarian berdasarkan tanggal order/no lab/nama pasien" v-model="searchText"  v-on:keyup.enter="search" />
              <vs-tooltip text="Edit" v-if="btnEdit === true">
                <vs-button radius size="large" type="border" color="warning" icon="edit" class="ml-3" @click="activePrompt=true;action='Update'"></vs-button>
              </vs-tooltip>
              <vs-tooltip text="Kirim Ke Worklist" v-if="btnEdit === true">
                <vs-button radius size="large" type="border" color="primary" icon="send" class="ml-3" @click="activePromptWorklist=true;action='Send'"></vs-button>
              </vs-tooltip>
              <vs-tooltip text="Hapus" v-if="btnDel === true">
                <vs-button radius size="large" type="border" color="danger" icon="delete" class="ml-3" @click="openConfirm"></vs-button>
              </vs-tooltip>
            </vs-col>
          </vs-row>
        </vx-card>
      </div>

      <vx-card title="Daftar Antrian Klinik" class="sticky-table-content1 mt-sticky">
        <vs-table max-items="10"
          :class="showFixedHeader?'sticky-header':''"
          :data="listData"
          @selected="handleSelected">
            <template slot="thead">
              <vs-th class="vs-lg-2">Tgl Order</vs-th>
              <vs-th class="vs-lg-3">Pasien</vs-th>
              <vs-th class="vs-lg-3">Data Lab</vs-th>
              <vs-th class="vs-lg-4">Pemeriksaan</vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody :key="indextr" v-for="(tr, indextr) in data">
                <vs-tr :data="tr" :style="tr.id==idSelected?'background: rgba(var(--vs-primary),.1)!important;':(indextr%2==0?'background: transparent!important;':'')">
                    <vs-td class="vs-lg-2 text-center" style="padding-left: 7px !important; padding-right: 7px !important">
                        {{data[indextr].visitDate | formatDate}}<br/>{{data[indextr].externalNumber}}
                    </vs-td>
                    <vs-td class="vs-lg-3">
                        <b>{{data[indextr].patient?data[indextr].patient.name:''}}{{' ('+(data[indextr].patient?data[indextr].patient.patientNumber:'')+')'}}</b><br/>
                        <label style="font-size: 12px">{{data[indextr].patient.dob | calcAge1}} {{(data[indextr].patient?(' / '+data[indextr].patient.gender.name):'')}}</label>
                    </vs-td>
                    <vs-td class="vs-lg-3 text-center">
                      <b>{{data[indextr].patientType.name}} | {{data[indextr].priority.name}}</b><br/>
                      <label style="font-size: 12px">{{data[indextr].ward.name}}</label>
                    </vs-td>
                    <vs-td class="vs-lg-4 text-center">
                        <span v-if='tr.testName!=null'>
                          <vs-chip :key="'test_name_' + j" v-for="(testName,j) in tr.testName" v-if="j < 4" :color="testName.colorValue">{{testName.name}}</vs-chip>
                      </span>
                    </vs-td>
                </vs-tr>
              </tbody>
            </template>
        </vs-table>
        <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>
      </vx-card>

       <vs-prompt class="w80"
         style="overflow: auto:"
         title="Konfirmasi Antrian Order Kirim ke Worklist"
         @accept="acceptAlert"
         accept-text="Kirim"
         cancel-text="Batal"
         color="#6488e4"
         :active.sync="activePromptWorklist">
          <patient :dataPatient="dataPatient" :subm="subm" :action="action" from="QueueClinic"/>
        </vs-prompt>

       <vs-prompt class="w80"
         style="overflow: auto:"
         title="Form Edit Order"
         @accept="onConfirm"
         accept-text="Simpan"
         cancel-text="Batal"
         color="#6488e4"
         :active.sync="activePrompt">
          <patient :dataPatient="dataPatient" @physician="physicianChg" @priority="priorityChg"
            @patientType="patientTypeChg" @ward="wardChg" @insurer="insurerChg"
            @listTestPatient="listTestPatientChg" :subm="subm" :action="action" from="QueueClinic"/>
        </vs-prompt>
    </div>
</template>

<script>
import visit from "@/api/visit";
import test from "@/api/test";
import Patient from '../Patient_';

export default {
  data() {
    return {
			idSelected: null,
			listData: [], 	
      listTest: [],
			perPage: 20,
			page: 1,
      totalItem: 1,
      btnEdit: false,
      btnDel: false,
			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
      activePromptWorklist:false,
      activePrompt:false,
      dataPatient: {},
      dataPatientModel: {},
      listColor: ['primary','success','danger','warning','dark'],
      subm: false,
      action: '',
      searchText: '',
      isUserScrolling: false,
      showFixedHeader: false,
      isMobile: false
    };
  },
  components: {
    Patient,
  },
  methods: {
    openConfirm() {
        this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: `Konfirmasi`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.acceptDelete
        })
    },
    acceptDelete() {
      let config = {
        headers: {
          "content-type": "application/json"
        }
      };

      const x = { id : this.idSelected }
      test.deleteQueue(x, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di hapus",
							color: "success",
							position: "top-right"
						});

            var index = this.listData.map((o) => o.id).indexOf(this.idSelected);
            this.listData.splice(index, 1);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
    },
    acceptAlert() {
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};

      const x = { id : this.idSelected }
      this.$vs.loading({
        type:'sound',
      });
			visit.toWorklist(x, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});

            var index = this.listData.map((o) => o.id).indexOf(this.idSelected);
            this.listData.splice(index, 1);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}

          this.$vs.loading.close()
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}

					this.$vs.loading.close();
				});
    },
    onConfirm() {
      this.activePrompt = false;
      this.subm = true;

      if (this.dataPatientModel.ward!=='') {
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Simpan data, data order akan diupdate ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.saveData
        })
        //this.saveData(this.dataPatientModel);
      }
    },
		async find(pg) {
			this.model["perPage"] = this.perPage;
      this.model["page"] = pg;
      this.model["lab_section_id"] = 1;

      this.$vs.loading({
        type:'sound',
      });

			const frm = await visit.queueClinicList(this.model);
			if (frm.data.status) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
			   this.listData = [];
      }
      this.$vs.loading.close();
		},
    handleSelected(tr) {
      this.idSelected = tr.id;
      this.btnEdit = true;
      this.btnDel = true;
      this.getDetail(tr.id);

      // saving model for edit
      this.dataPatientModel.patient = {id: tr.patient.id};
      this.dataPatientModel.physician = {id: tr.physician.id};
      this.dataPatientModel.insurer = {id: tr.insurer.id};
      this.dataPatientModel.ward = {id: tr.ward.id};
      this.dataPatientModel.priority = {id: tr.priority.id};
      this.dataPatientModel.patientType = {id: tr.patientType.id};
      this.dataPatientModel.wrap = {measures: tr.wrap.measures};
    },
    saveData() {
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};

      const model = this.dataPatientModel;
      //model.wardName = model.ward;
      //model.ward = null;
      model.labSection = {id : 1};
      model.id = this.idSelected;
console.log('model:'+JSON.stringify(model));
      this.$vs.loading({
        type:'sound',
      });

			test.updateQueue(model, config)
				.then(res => {
          this.activePrompt=false;
					if (res.data.status) {
            this.$vs.notify({
              title: "Notifikasi",
              time: 3000,
              text: 'Data Order telah berhasil di update',
              color: "success",
              position: "top-right"
            });

            this.find(this.page);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}

          this.$vs.loading.close();
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
        .finally();
		},
		async getDetail(id) {
      this.$vs.loading({
        type:'sound',
      });
			const frm = await visit.getDetailQueue(id);
			if (frm.data.status) {
				this.dataPatient= frm.data.data[0];
			}
      this.$vs.loading.close();
		},
    physicianChg(arg) {
      this.dataPatientModel.physician = {id: arg};
    },
    priorityChg(arg) {
      this.dataPatientModel.priority = {id: arg};
    },
    patientTypeChg(arg) {
      this.dataPatientModel.patientType = {id: arg};
    },
    wardChg(arg) {
      this.dataPatientModel.ward = {id: arg};
    },
    insurerChg(arg) {
      this.dataPatientModel.insurer = {id: arg};
    },
    listTestPatientChg(arg) {
      this.dataPatientModel.wrap = {measures:arg}
    },
    handleScroll(ev) {
      if(!this.isMobile) {
          this.isUserScrolling = (window.scrollY > 0);
          if (this.isUserScrolling) {
              if (window.pageYOffset > 45) {
                  this.showFixedHeader = true;
              } else {
                  this.showFixedHeader = false;
              }
          } else {
              this.showFixedHeader = false;
          }
      }
    },
    setFocusOnInput(inputName) {
       /**
        * @see https://vuejs.org/v2/api/#vm-el
        * @see https://vuejs.org/v2/api/#vm-refs
        */
        // you could just call this.$refs[inputName].focusInput() but i'm not shure if it belongs to the public API
        let inputEl = this.$refs[inputName].$el.querySelector('input');
        console.log(inputEl.focus);
        inputEl.focus();
    },
    isMobileDevice() {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        console.log(navigator.userAgent);

        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    },
		async search() {
      this.page = 1;
			this.model["perPage"] = this.perPage;
      this.model["page"] = 1;
      this.model["lab_section_id"] = 1;
      this.model["keyword"] = this.searchText

      this.$vs.loading({
        type:'sound',
      });

			const frm = await visit.queueClinicList(this.model);
			if (frm.data.status) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
			   this.listData = [];
      }
      this.$vs.loading.close();
		},
  },
  computed: {
  },
  mounted() {
      this.isMobile = this.isMobileDevice();
  },
  created() {
      document.addEventListener('scroll', this.handleScroll);
      this.$nextTick(() => this.setFocusOnInput('searchTxt'))
  },
  destroyed() {
      document.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss">
.w50 .vs-dialog {
    max-width:50%;
}

.w80 .vs-dialog {
    max-width:80%;
}
.vs-dialog {
    max-height: 90%;
    overflow-y: auto;
}
.vs-dialog-header {
    padding-right: 22px;
    padding-top: 10px;
}
.vs-table tbody tr:hover {
    border:none;
}
</style>
